import { compose } from "recompose";
import withApiErrorWrapper from "../HandleApiErrorWrapperNonRedux";
import withUserRoles from "../WithUserRoles";
import StoreDetailsPageWrapper from "./StoreDetailsPageWrapper";
import withBanners from "../WithBanners/WithBanners";
import withManagersOverrideToastConsumer from "../WithManagersOverrideToastManager";

export default compose(
  withApiErrorWrapper,
  withUserRoles,
  withBanners,
  withManagersOverrideToastConsumer
)(StoreDetailsPageWrapper);
